import React, { useState } from 'react';
import axios from 'axios';
export const CartContext = React.createContext(null);


function CartContextProvider(props){

  const [counter, setCounter] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [wishListId, setWishlistId] = useState(null);
  const [wishlist, setWishlist] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [qtyloading, setQtyLoading] = useState(false);
  const [cartId, setCartId] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  const [displayRazorpay, setDisplayRazorpay] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderItems,setOrderItems] = useState([]);


  function setCartItemsArray(userCart) {
    console.log(cartId);
    console.log(userCart);
    if (userCart.length > 0) {
      userCart.map(e => {
        if (e !== undefined && e !== null) {
          const fetchProduct = async () => {
            try {
              const response = await axios.get(`https://jackpotbackend.vercel.app/product/${e.id}`);
              addCartItemfirst(response.data, e.qty);

            } catch (error) {
              console.error('Error fetching product details:', error);
            }
          };

          fetchProduct().finally(
            () => {
              setTimeout(() => {
                setInitialLoading(false);
              }, 1)
            }
          );
        }

        return 0;
      })
    }
    else {
      setInitialLoading(false)
      return -1;
    }
  }

  function setWishlistItemsArray(userWishlist) {
    // console.log(userWishlist);
    if (userWishlist.length > 0) {
      userWishlist.map(e => {
        if (e !== undefined && e !== null) {
          const fetchProduct = async () => {
            try {
              const response = await axios.get(`https://jackpotbackend.vercel.app/product/${e.itemId}`);
              addWishlistItemfirst(response.data);

            } catch (error) {
              console.error('Error fetching product details:', error);
            }
          };

          fetchProduct().then(setInitialLoading(false));

        }

        return 0;
      })
    }
    else {
      setInitialLoading(false)
      return -1;
    }
  }





  function addCartItemfirst(item, qty) {

    const isExisting = cartItems.find((cartItem) => cartItem.id === item.id);
    if (!isExisting) {
      setCartItems(prevCartItems => [...prevCartItems, { ...item, quantity: qty }]);
      setCounter(prevCounter => prevCounter + 1);
      setTotalPrice(prevTotalPrice => prevTotalPrice + (item.price * qty));

    }
  }

  function addWishlistItemfirst(item, qty) {
    setWishlist(prevWishlistItems => [...prevWishlistItems, { ...item }]);
  }


  async function addCartItem(item, qty) {
    try {
      await axios.post(`https://jackpotbackend.vercel.app/cart/${cartId}/add/item/${item.id}/qty/${qty}`);
      setCartItems(prevCartItems => [...prevCartItems, { ...item, quantity: qty }]);
      setCounter(prevCounter => prevCounter + 1);
      setTotalPrice(prevTotalPrice => prevTotalPrice + (item.price * qty));

    } catch (error) {
      alert("cart item not added,please try again ")
      console.error('Error fetching product details:', error);
    }
  }


  async function updateQuantity(item, qty) {
    setQtyLoading(true)
    try{
      await axios.post(` https://jackpotbackend.vercel.app/cart/${cartId}/update/item/${item.id}/qty/${qty}`);
      setQtyLoading(false)
      const prevPrice = item.price * item.quantity;
      const updatedCart = cartItems.map((cartItem) =>
        cartItem.id === item.id ? { ...cartItem, quantity: qty } : cartItem
      );

      // Avoid using toFixed() here for updating total price
      const updatedTotalPrice = (totalPrice + (item.price * qty)) - prevPrice;

      setCartItems(updatedCart);
      setTotalPrice(updatedTotalPrice);
    }
    catch (error) {
      console.log("could not update quantity please try again " + error);
      alert("could not update quantity please try again " + error)
      setQtyLoading(false)
    }

  }

  async function removeCartItem(item) {
try {    
    const updatedCart = cartItems.filter((cartItem) => cartItem.id !== item.id);
    const itemToRemove = cartItems.find((cartItem) => cartItem.id === item.id);
    await axios.post(`https://jackpotbackend.vercel.app/cart/${cartId}/remove/item/${item.id}`);

      const deduction = itemToRemove.price * itemToRemove.quantity;
      const updatedTotalPrice = totalPrice > deduction ? totalPrice - deduction : 0;

      setTotalPrice(updatedTotalPrice);
      setCartItems(updatedCart);
      setCounter(counter > 0 ? counter - 1 : 0);
      console.log(cartItems);
    }
    catch (error) {
      console.log("could not delete item,please try again");
    }
  }




  // To render the actual category and type of clothes
  const [category, setCategory] = useState("casuals/all");

  function updateCategory(link) {
    setCategory(link);
  }


  // To Identity whether clicked link is casuals or formals
  const [catOnly, setCatOnly] = useState("casuals/all");
  function updateCatOnly(c) {
    setCatOnly(c)
  }



  const addToWishlist = async (item) => {
    setWishlist((prevWishlist) => [...prevWishlist, item]);

    try {
      await axios.post(`https://jackpotbackend.vercel.app/wishlist/${wishListId}/add/${item.id}`);
      console.log(wishListId);

    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  };

  const removeFromWishlist = async (shirt) => {
    const updatedWishlist = wishlist.filter((item) => item.id !== shirt);
    setWishlist(updatedWishlist);


    try {
      await axios.post(`https://jackpotbackend.vercel.app/wishlist/${wishListId}/remove/${shirt}`);

    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  };

  const fetchOrderItems = async (items) => {
        console.log("test" + items[0]);
        setOrderItems(items => []);
        if(items.length > 0){
          items.map(async e => {
            try {
              const response = await axios.get(`https://jackpotbackend.vercel.app/product/${e.id}`);
              setOrderItems(prevItems => {
                return [...prevItems,{...response.data,qty:e.qty}]
              })
              console.log(orderItems);
            } catch (error) {
              console.error('Error fetching order items:',error);
            }
          })
        }
  }

  



  return (

    <CartContext.Provider value={{ displayRazorpay, userId, cartId, orderSuccess,orderItems,fetchOrderItems, setOrderSuccess, setDisplayRazorpay, searchResult, setSearchResult, qtyloading, initialLoading, addToWishlist, removeFromWishlist, setInitialLoading, user, setUser, setUserId, setCartItemsArray, setCartItems, setCounter, setTotalPrice, counter, cartItems, totalPrice, updateQuantity, addCartItem, removeCartItem, category, updateCategory, catOnly, updateCatOnly, setWishlist, wishlist, wishListId, setWishlistId, setWishlistItemsArray, setCartId }}> {/* Provide cart and addToCart */}


      {props.children}

    </CartContext.Provider>
  );

}


export default CartContextProvider;